/** @format */

export const Projects = [
  {
    title: "OpenFashion",
    cardName: "E-Commerce Website",
    summary:
      "A full-stack e-commerce website which allows users to browse, review and purchase products.",
    stack: ["React.js", "Node.js", "Stripe", "EmailJS"],
    github: "https://github.com/Wahaj-Arsal/OpenFashion",
    url: "https://openfashion.onrender.com",
    image: "openfashion_v2.jpg",
  },
  {
    title: "Happy Bites",
    cardName: "Dessert AI and shop",
    summary:
      "HappyBites is a place to ask AI for your next dessert idea or if you're feeling lazy to buy your desserts.",
    stack: ["JavaScript", "ChatGPT API"],
    github: "https://github.com/Wahaj-Arsal/happy_bites",
    url: "https://technative-academy.github.io/happy_bites/",
    image: "happy_bites.png",
  },
  // {
  //   title: "QuizLab",
  //   cardName: "Quiz Library",
  //   summary:
  //     "A full-stack web application quiz, where users can take part in quizes from different categories.",
  //   stack: ["React.js", "Node.js"],
  //   github: "https://github.com/Wahaj-Arsal/Quiz",
  //   url: "https://quiz-fg8t.onrender.com/",
  //   image: "openfashion_v2.jpg",
  // },
  {
    title: "PlayFlix",
    cardName: "Streaming Website",
    summary:
      "A full-stack streaming web application which allows users to upload videos, create and delete comments",
    stack: ["React.js", "Node.js", "Express"],
    github: "https://github.com/Wahaj-Arsal/Play_Flix",
    url: "https://playflix.onrender.com",
    image: "playflix.jpg",
  },
  {
    title: "Puddle of Chords",
    cardName: "Band Site",
    summary:
      "A full-stack streaming web application which allows users to upload videos, create and delete comments",
    stack: ["React.js", "Node.js", "Express"],
    github: "https://github.com/Wahaj-Arsal/Chords",
    url: "https://puddleofchords.netlify.app",
    image: "chords.jpg",
  },
  {
    title: "Bramble & Co",
    cardName: "Organic food website",
    summary:
      "This project demonstrates a fully functional multi-page website built from a supplied design brief. It focuses on semantic HTML structure, modular CSS, and JavaScript for interactivity.",
    stack: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/Wahaj-Arsal/brambleandco",
    url: "https://brambleandco.onrender.com/",
    image: "bramble_co.png",
  },
];
